export default __webpack_public_path__ + "static/media/barbecue_image.bfecf6c1.svg";